let Scroll = require('../components/Scroll');

class Mouse {
    constructor(sections) {
        let links = sections;

        let mouse = document.querySelector('.js-mouse');

        let hasScroll = false;
        mouse.addEventListener('click', () => {
            for (let i = 0; i < links.length; i++) {
                if (links[i].classList.contains('active') && i < links.length - 1) {
                    this._scrollTo(links[i + 1]);
                    hasScroll = true;
                    break;
                }
            }

            if (!hasScroll) {
                this._scrollTo(links[0]);
            }
        });
    }

    _scrollTo(element) {
        let attribute = element.hasAttribute('href') ? 'href' : 'data-target';
        new Scroll().to(document.querySelector(element.getAttribute(attribute)));
    }

}

module.exports = Mouse;